import { ref, onMounted, onUnmounted } from 'vue'
import { getPreset, REDUCED_MOTION_TRANSITION } from '@/utils/motionPresets'

const QUERY = '(prefers-reduced-motion: reduce)'

export function useClinchMotion() {
  const prefersReducedMotion = ref(false)
  let media

  const update = () => {
    prefersReducedMotion.value = media?.matches ?? false
  }

  onMounted(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    media = window.matchMedia(QUERY)
    update()
    media.addEventListener('change', update)
  })

  onUnmounted(() => {
    media?.removeEventListener('change', update)
  })

  function resolvePreset(presetName) {
    const preset = getPreset(presetName)
    if (!prefersReducedMotion.value) {
      return { ...preset }
    }
    return {
      initial: preset.animate || preset.initial || {},
      animate: preset.animate || preset.initial || {},
      exit: preset.animate || {},
      transition: REDUCED_MOTION_TRANSITION,
      whileHover: undefined,
      whileTap: undefined,
      whileInView: preset.animate || preset.initial
    }
  }

  function mergeMotionProps(presetName, overrides = {}) {
    const base = resolvePreset(presetName)
    return {
      initial: overrides.initial ?? base.initial,
      animate: overrides.animate ?? base.animate,
      exit: overrides.exit ?? base.exit,
      transition: prefersReducedMotion.value
        ? REDUCED_MOTION_TRANSITION
        : overrides.transition ?? base.transition,
      whileHover: prefersReducedMotion.value ? undefined : overrides.whileHover ?? base.whileHover,
      whileTap: prefersReducedMotion.value ? undefined : overrides.whileTap ?? base.whileTap,
      whileInView: prefersReducedMotion.value
        ? overrides.animate ?? base.animate
        : overrides.whileInView ?? base.whileInView,
      viewport: overrides.viewport ?? base.viewport,
      layout: overrides.layout ?? base.layout
    }
  }

  return {
    prefersReducedMotion,
    resolvePreset,
    mergeMotionProps
  }
}
